var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHandshake(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M25 19.1077L20.4004 23.7073C20.2783 23.8294 20.1266 23.9179 19.9602 23.9639C19.7938 24.01 19.6182 24.0123 19.4507 23.9704L12.2061 22.1592C12.0702 22.1253 11.943 22.0631 11.8326 21.9768L5 16.634L9.0718 8.97373L15.4868 7.10353C15.716 7.03673 15.9614 7.05409 16.1789 7.1525L20.5 9.1077H17.9142C17.7829 9.1077 17.6529 9.13356 17.5315 9.18382C17.4102 9.23407 17.3 9.30773 17.2071 9.40059L12.3153 14.2924C12.214 14.3937 12.1356 14.5156 12.0855 14.6498C12.0354 14.7841 12.0148 14.9275 12.0249 15.0704C12.0351 15.2133 12.0758 15.3524 12.1444 15.4782C12.213 15.604 12.3078 15.7135 12.4224 15.7995L13.1 16.3077C13.7924 16.827 14.6345 17.1077 15.5 17.1077C16.3655 17.1077 17.2076 16.827 17.9 16.3077L19.5 15.1077L25 19.1077Z",
    fill: "#23BD33"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0897 15.2231L27 16.768L23 9.10771L26.1212 7.54713C26.3557 7.42989 26.6268 7.40942 26.8763 7.49013C27.1257 7.57085 27.3335 7.74629 27.4548 7.97869L30.5289 13.8658C30.5904 13.9835 30.6278 14.1123 30.639 14.2446C30.6501 14.377 30.6348 14.5102 30.5939 14.6366C30.553 14.7629 30.4874 14.8799 30.4008 14.9806C30.3143 15.0813 30.2085 15.1637 30.0897 15.2231V15.2231Z",
    stroke: "#23BD33",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.00003 16.634L1.91032 15.0891C1.79154 15.0297 1.68578 14.9473 1.59921 14.8466C1.51264 14.7459 1.447 14.6289 1.40611 14.5026C1.36522 14.3762 1.34991 14.243 1.36107 14.1107C1.37223 13.9783 1.40964 13.8495 1.47111 13.7318L4.54523 7.84469C4.66658 7.6123 4.87434 7.43685 5.12378 7.35613C5.37321 7.27541 5.64437 7.29588 5.87887 7.41313L9.00003 8.97371L5.00003 16.634Z",
    stroke: "#23BD33",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27 16.7679L25 19.1077L20.4004 23.7073C20.2783 23.8294 20.1266 23.9178 19.9602 23.9639C19.7938 24.01 19.6182 24.0122 19.4507 23.9703L12.2061 22.1592C12.0702 22.1252 11.943 22.0631 11.8326 21.9768L5 16.6339",
    stroke: "#23BD33",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25 19.1077L19.5 15.1077L17.9 16.3077C17.2076 16.827 16.3655 17.1077 15.5 17.1077C14.6345 17.1077 13.7924 16.827 13.1 16.3077L12.4224 15.7995C12.3078 15.7135 12.213 15.604 12.1444 15.4782C12.0758 15.3524 12.0351 15.2133 12.0249 15.0704C12.0147 14.9275 12.0354 14.7841 12.0855 14.6498C12.1356 14.5156 12.214 14.3937 12.3153 14.2924L17.2071 9.40059C17.2999 9.30773 17.4102 9.23407 17.5315 9.18382C17.6528 9.13356 17.7829 9.1077 17.9142 9.1077H23",
    stroke: "#23BD33",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.07164 8.97369L15.4866 7.1035C15.7158 7.0367 15.9613 7.05406 16.1788 7.15246L20.4998 9.10767",
    stroke: "#23BD33",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14 26.6077L10.2326 25.6658C10.0797 25.6276 9.938 25.5538 9.81907 25.4504L7 23",
    stroke: "#23BD33",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandshake);
export default __webpack_public_path__ + "static/media/Handshake.31afb8b9e281e1851600780f52f2bcda.svg";
export { ForwardRef as ReactComponent };